import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from './SEO';
import './HomePage.css';
import './utils/buttons.css';
import './DownloadPage.css';

export function getDownloadPlatform({ userAgent, platform, maxTouchPoints }) {
  if (/Windows Phone/i.test(userAgent)) return null;
  if (/Android/i.test(userAgent)) return 'android';
  if (/iPad|iPhone|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1)) {
    return 'ios';
  }
  return null;
}

function DownloadPage() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const platform = getDownloadPlatform(navigator);
  const language = i18n.resolvedLanguage.split('-')[0];
  const storeUrl = platform === 'ios'
    ? 'https://apps.apple.com/app/taptrap-party-game/id6742859366'
    : platform === 'android'
      ? `https://play.google.com/store/apps/details?id=app.taptrap&hl=${language}`
      : null;

  useEffect(() => {
    if (!storeUrl) return;

    let timer;
    const scheduleRedirect = () => {
      timer = window.setTimeout(() => window.location.replace(storeUrl), 500);
    };

    if (document.readyState === 'complete') {
      scheduleRedirect();
    } else {
      window.addEventListener('load', scheduleRedirect, { once: true });
    }

    return () => {
      window.removeEventListener('load', scheduleRedirect);
      window.clearTimeout(timer);
    };
  }, [storeUrl]);

  if (!platform) return <Navigate to={{ pathname: '/', search: location.search }} replace />;

  return (
    <section className="download-page" aria-label="TapTrap">
      <SEO title="Download TapTrap" noindex themeColor="#c119fa" />
      <img className="download-page-logo" src="/assets/home/taptrap-logo.svg" alt="TapTrap" />
      <p className="download-page-status" role="status">
        {t('download.redirecting', { store: platform === 'ios' ? 'App Store' : 'Google Play' })}
      </p>
      <div className="home-download-buttons">
        <a href={storeUrl} className={`btn ${platform === 'ios' ? 'primary' : 'secondary'} home-store-button`}>
          <img src={`/assets/icon-${platform === 'ios' ? 'apple' : 'android'}.svg`} alt="" className="btn-icon" />
          <span>{t(platform === 'ios' ? 'home.getIOS' : 'home.getAndroid')}</span>
        </a>
      </div>
    </section>
  );
}

export default DownloadPage;
